export class PartnerManagementToken {
  static IB2CPartnerManagementRepository = Symbol(
    "IB2CPartnerManagementRepository",
  );
  static B2CPartnerManagementUseCase = Symbol("B2CPartnerManagementUseCase");
  static B2CPartnerManagementViewModel = Symbol(
    "B2CPartnerManagementViewModel",
  );
}
